import { prijs_afmetingen_vliegramen, prijs_gaas } from "./prices";

const PRICE_OPMETING = 150;

export const calculate_price = (order) => {


    console.log(Object.keys(prijs_afmetingen_vliegramen))
    
    const w =order.DIMENSION.WIDTH //mm
    const h = order.DIMENSION.HEIGHT //mm


    const w_st = roundToNearest(w, Object.keys(prijs_afmetingen_vliegramen[500])) // mm
    const h_st = roundToNearest(h, Object.keys(prijs_afmetingen_vliegramen)) // mm


    const area = w*1 * h*1 / 1000000 // meters
    const aantal = order.AANTAL;

    const prijs_frame = prijs_afmetingen_vliegramen[h_st][w_st];
    const prijs_kleur = 0;
    const prijs_gaas_totaal = prijs_gaas[order.GAAS_TYPE]
    
    const totaal_prijs = (prijs_frame*1 + prijs_kleur*1 + prijs_gaas_totaal*1) * (aantal*1);

    console.log(prijs_frame)
    console.log(prijs_gaas_totaal)
    console.log(totaal_prijs)

    return ({...order, prijs: totaal_prijs})
}

export const calculate_total_price = (orders) => {
    const extra_opmeting = orders.find(o => o.OPMETING);
    const extra_opmeting_price = extra_opmeting ? PRICE_OPMETING : 0 ;
    const total_price = orders.reduce((total,p) => total + 1*p.prijs, 0)*1 + extra_opmeting_price*1;
    return total_price
}

const roundToNearest = (value, availableSizes) => {
    // Converteer de keys naar getallen en zoek de dichtstbijzijnde
    const sizes = availableSizes.map(Number);
    return sizes.reduce((nearest, size) => 
      Math.abs(size - value) < Math.abs(nearest - value) ? size : nearest, sizes[0]);
  }
  